import {
  AnaliseDesempenhoProcessosWeb,
  AnaliseDesempenhoProcessosWebDetalhamento,
  AnaliseDesempenhoProcessosWebProcessos,
} from '@containers';
import { InfoUsuario } from '@utils';

const getPermissaoFila = (infoUsuario) => InfoUsuario.perm('admin') || InfoUsuario.perm('fila');

export default [
  {
    path: '/analise-desempenho/processos-web',
    parent: '/analise-desempenho',
    text: 'Processos Web',
    match: /^\/analise-desempenho\/processos-web?/,
    sider: true,
    component: AnaliseDesempenhoProcessosWeb,
    exact: true,
    secret: true,
    permissions: (infoUsuario) => getPermissaoFila(infoUsuario),
  },

  {
    path: '/analise-desempenho/processos-web/processos/:tipoProcesso/:lote',
    parent: '/analise-desempenho',
    component: AnaliseDesempenhoProcessosWebProcessos,
    exact: true,
    secret: true,
    permissions: (infoUsuario) => getPermissaoFila(infoUsuario),
  },

  {
    path: '/analise-desempenho/processos-web/:id',
    parent: '/analise-desempenho',
    component: AnaliseDesempenhoProcessosWebDetalhamento,
    exact: true,
    secret: true,
    permissions: (infoUsuario) => getPermissaoFila(infoUsuario),
  },
];
